import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { Spin } from 'antd';
import { userHooks } from 'hooks';
import { userServices } from 'services';
import { IRoute } from 'interfaces';
import { StoreContext } from 'contexts';

const PrivateRoute = ({
  component: Component,
  ...rest
}: Omit<IRoute, 'name'>) => {
  // Check if user is logged in or not
  userServices.isLoggedIn().then(isLogged => {
    if (!isLogged) {
      userServices.login();
      return null;
    }
  });

  // Fetch global data
  const { currentUser } = userHooks.useUserInfo();

  useEffect(() => {
    if (currentUser) track('setUserId', currentUser.sub);
    if (currentUser) {
      if (
        !currentUser.meta_data ||
        !currentUser.meta_data.COMPANY_ID ||
        !currentUser.meta_data.COMPANY_ID.includes(
          window.COMPANY_IN_WEB.toString()
        )
      ) {
        userServices.logout();
      }
    }
  }, [currentUser]);

  // Show spin when fetching required global data
  if (!currentUser) {
    return <Spin className="app-spin" />;
  }

  return (
    <StoreContext.Provider
      value={{
        currentUser,
      }}
    >
      <Route {...rest} render={routeProps => <Component {...routeProps} />} />
    </StoreContext.Provider>
  );
};

export default PrivateRoute;
